export const LANDING_VIEW = 'Landing';
export const NO_AUTH_VIEW = 'NoAuth';
export const AUTH_VIEW = 'Auth';
